export function popupReviewCarousel(html, numReviews) {
    if ($('#popup-carousel').length) {
        $('#popup-carousel').remove();
    }
    let dialog =
        "<div id='popup-carousel' class='modal fade popup-carousel' tabindex='-1'>" +
        "<div class='modal-dialog'>" +
        "<div class='modal-content'>" +
        "<button type='button' class='close' data-dismiss='modal' aria-hidden='true' style='position: absolute;right: 5px;z-index: 1;font-size: 25px;'>×</button>" +
        "<div class='modal-body'>" +
        "<div id='review-carousel'>" +
        html +
        "</div></div></div></div></div>";
    $(dialog).modal();
    setTimeout(function() {

        $('#review-carousel').slick(
            {
                infinite: true,
                lazyLoad: 'progressive',
                prevArrow: '<div class="img-carousel-nav img-carousel-prev"><span class="glyphicon glyphicon-menu-left" style="position: absolute; top: 50%; z-index: 500;"></span></div>',
                nextArrow: '<div class="img-carousel-nav img-carousel-next"><span class="glyphicon glyphicon-menu-right" style="position: absolute; top: 50%; z-index: 500;right: 10px;"></span></div>',
                slidesToShow: 1,
                //variableWidth: true,
                centerMode: false,
                adaptiveHeight: numReviews > 1,
                arrows: true
            }
        );
        $('#review-carousel').on('lazyLoaded', function(event, slick, image, imageSource) {
            $("<img/>",{
                load : function(){
                    let parentHeight = $('#review-container').height();
                    let parentWidth = $('#review-container').width();
                    let width = parentWidth * 0.90;
                    $(image).css({
                        'width':width + 'px',
                        'padding': '0 20px 0 40px'
                    });

                    if (this.height > this.width) {
                        $(image).addClass('vertical');
                        $(image).css({
                                'height' : 'auto'
                        });
                    }
                    else if (this.width > this.height) {
                        $(image).css({
                            'width':width + 'px',
                            'padding': '0 20px 0 40px'
                        });
                    }
                },
                src  : imageSource
            });
        });
    }, 150);
}